import React from "react";
import "./AstroVastu.css";
import vastuBanner from "../assets/zodiac/Aquarius.jpg";
import BlogSlider from "../components/BlogSlider";
import ServiceProduts from "../components/ServiceProduts";
import ContactForm from "../components/ContactForm"; 

const LoveAstrology = () => {
  return (
    <div className="services-page">
      {/* Left Side - 67% Text Content */}
      <div className="services-content">
       
                         <h1>Love Astrology: Your Cosmic Guide to Relationships</h1>
    
    <div class="highlight-box">
        <p>Love astrology reveals the deepest mysteries of your heart through planetary positions at birth. Our precise love marriage predictions and compatibility analysis help you understand relationship potentials, challenges, and karmic connections.</p>
    </div>

    <div class="couplet">
       
        

        <p>पोथी पढ़ पढ़ जग मुआ, पंडित भया न कोए |</p>
        <p>ढाई अक्षर प्रेम का, पढ़े सो पंडित होए ||</p>
        <p> "The world dies reading scriptures, yet none becomes wise.</p>
        <p>One who understands the two-and-a-half letters of love, becomes truly enlightened."</p>
    </div>
    

    <h2>Love Houses in Your Birth Chart</h2>
    
    <div class="zodiac-love">
        <div class="zodiac-card">
            <h3>5th House (Romance)</h3>
            <p>Reveals your approach to courtship, creative expression in love, and capacity for joy in relationships. Strong Venus here indicates natural charm.</p>
        </div>
        <div class="zodiac-card">
            <h3>7th House (Marriage)</h3>
            <p>Shows your marriage potential, partner characteristics, and long-term relationship patterns. Afflictions here may delay marriage.</p>
        </div>
        <div class="zodiac-card">
            <h3>8th House (Intimacy)</h3>
            <p>Governs sexual compatibility, emotional bonding, and transformative experiences through relationships. Reveals depth of connection.</p>
        </div>
    </div>

    <h2>Planetary Influences on Love Life</h2>
    
    <div class="planetary-influence">
        <h3>Venus (Shukra) - Planet of Love</h3>
        <p>Governs romance, attraction, and relationship harmony. Its position reveals what you find beautiful and how you express affection.</p>
    </div>
    
    <div class="planetary-influence">
        <h3>Mars (Mangal) - Planet of Passion</h3>
        <p>Controls sexual energy, assertiveness in relationships, and how you pursue romantic interests. Affects compatibility between partners.</p>
    </div>
    
    <div class="planetary-influence">
        <h3>Moon (Chandra) - Planet of Emotions</h3>
        <p>Influences emotional needs in relationships, nurturing style, and subconscious patterns in love connections.</p>
    </div>

    <h2>Zodiac Compatibility for Love Marriage</h2>
    
    <table class="compatibility-table">
        <tr>
            <th>Zodiac Sign</th>
            <th>Best Matches</th>
            <th>Love Marriage Potential</th>
            <th>Key Traits in Love</th>
        </tr>
        <tr>
            <td>Aries (March 21-April 19)</td>
            <td>Leo, Sagittarius, Gemini</td>
            <td>High (85%)</td>
            <td>Passionate, direct, loyal</td>
        </tr>
        <tr>
            <td>Gemini (May 21-June 20)</td>
            <td>Libra, Aquarius, Leo</td>
            <td>High (80%)</td>
            <td>Communicative, adaptable, social</td>
        </tr>
        <tr>
            <td>Leo (July 23-Aug 22)</td>
            <td>Aries, Sagittarius, Gemini</td>
            <td>High (75%)</td>
            <td>Generous, dramatic, warm-hearted</td>
        </tr>
        <tr>
            <td>Libra (Sep 23-Oct 22)</td>
            <td>Gemini, Aquarius, Leo</td>
            <td>Very High (90%)</td>
            <td>Romantic, diplomatic, harmony-seeking</td>
        </tr>
        <tr>
            <td>Sagittarius (Nov 22-Dec 21)</td>
            <td>Aries, Leo, Aquarius</td>
            <td>High (80%)</td>
            <td>Adventurous, optimistic, freedom-loving</td>
        </tr>
        <tr>
            <td>Aquarius (Jan 20-Feb 18)</td>
            <td>Gemini, Libra, Sagittarius</td>
            <td>Moderate (65%)</td>
            <td>Unconventional, intellectual, independent</td>
        </tr>
    </table>

    <h2>Love Marriage Predictions by Zodiac</h2>
    
    <div class="zodiac-love">
        <div class="zodiac-card">
            <h3>Aries Love Profile</h3>
            <p>Fiery and passionate, Aries natives approach love with bold enthusiasm. Ruled by Mars, they need partners who appreciate their directness. Best love matches come when Venus aspects their 7th house between ages 24-28.</p>
        </div>
        <div class="zodiac-card">
            <h3>Gemini Love Profile</h3>
            <p>Mercury-ruled Geminis seek mental connection first. Their dual nature needs partners who provide both intellectual stimulation and emotional security. Strongest love potential when Jupiter transits their 5th house.</p>
        </div>
        <div class="zodiac-card">
            <h3>Leo Love Profile</h3>
            <p>Sun-ruled Leos love grand romantic gestures. They thrive with partners who admire them while asserting independence. Venus-Mars conjunctions in their chart indicate passionate love matches.</p>
        </div>
    </div>
    
    <div class="zodiac-love">
        <div class="zodiac-card">
            <h3>Libra Love Profile</h3>
            <p>Venus-ruled Librans are natural romantics seeking balance. They blossom in harmonious relationships and often find love when Saturn aspects their 7th house, bringing maturity to partnerships.</p>
        </div>
        <div class="zodiac-card">
            <h3>Sagittarius Love Profile</h3>
            <p>Jupiter-ruled Sagittarians value freedom in love. Their ideal partners share their adventurous spirit. Love marriage likely when North Node transits their relationship houses between ages 27-33.</p>
        </div>
        <div class="zodiac-card">
            <h3>Aquarius Love Profile</h3>
            <p>Unconventional Aquarians approach love intellectually. They need partners respecting their independence. Strong Uranus aspects in their composite charts indicate transformative love connections.</p>
        </div>
    </div>

    

    <div class="highlight-box">
        <p>Remember: While love astrology reveals your relationship potentials, your actions and choices ultimately shape your romantic destiny. As the stars guide but don't determine, approach love with both cosmic wisdom and personal responsibility.</p>
    </div>

        {/* FAQs */}
        <div className="faq-section">
          <h3>Frequently Asked Questions</h3>
          <div className="faq"><h4>What is Astro Vastu?</h4><p>Astro Vastu combines Vastu Shastra with astrology to bring personalized solutions based on your birth chart.</p></div>
          <div className="faq"><h4>Can this service be done remotely?</h4><p>Yes, we offer remote consultations through video calls and shared floor plans.</p></div>
          <div className="faq"><h4>How do I choose a gemstone?</h4><p>We analyze your birth chart and planetary positions to recommend suitable gemstones.</p></div>
          <div className="faq"><h4>What is the benefit of Rudraksha?</h4><p>Rudraksha beads help in spiritual growth and balancing chakras and energy fields.</p></div>
        </div>

        {/* Blog Slider */}
            <div className="recent-blogs">
                    
                     <BlogSlider />
            </div>

    </div>

      {/* Right Side - 33% Banner Image, Contact, Social, Buy */}
      <div className="sidebar">
        <div className="banner-image">
          <img src="/assets/profile/Jyotish_karam_profile.jpeg" alt="Astro Vastu Services Banner" />
        </div>

        <div className="social-follow">
          <h4>Follow Us</h4>
          <div className="social-icons">
            <a href="#"><i className="fab fa-facebook-f" /></a>
            <a href="#"><i className="fab fa-instagram" /></a>
            <a href="#"><i className="fab fa-twitter" /></a>
            <a href="#"><i className="fab fa-linkedin-in" /></a>
            <a href="#"><i className="fab fa-pinterest-p" /></a>
            <a href="#"><i className="fab fa-youtube" /></a>
          </div>
        </div>

        <ContactForm />

       
          <ServiceProduts />
        
      </div>
    </div>
  );
};

export default LoveAstrology;
